/* eslint-disable no-console */
import { Wrap, StyledPaper } from './styles';

import ItemList from './components/ItemList';

import Icon from '@map/components/Icons';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useEffect } from 'react';


/**
 * MultiSelect
 * 
 * @param {string} name
 * @param {string} placeholder
 * @param {string} type
 * @param {function} onChange
 * @param {*} value
 * @param {Array} data
 * @param {*} defaultValue
 * @param {boolean} avoidMobileBehavior
 * 
 * @returns 
 */
const MultiSelect = ({
  name,
  placeholder,
  type,
  onChange,
  value,
  data,
  defaultValue,
  avoidMobileBehavior = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (defaultValue && data.length !== 0) {
      data.unshift({label: defaultValue, value: defaultValue})
    }    
  }, [defaultValue, data]);
  
  /**
   * Manuseia a mudança de valores
   *
   * @param {object} e
   */
  const handleChange = (e) => {
    const newValue = e.target.value;
    const checked = e.target.checked;

    if (type === 'radio' && checked && newValue !== value) {
      let onChangeValue = newValue;
      onChange && onChange(onChangeValue);   
      handleClosePopOver();
    } else if (type === 'checkbox') {
      let newArray;
      if (checked && !value.includes(newValue)) {
        newArray = [...value, newValue];
      } else if (!checked) {
        newArray = value.filter((v) => v !== newValue);
      }
      onChange && onChange(newArray);
    }
  };

  /**
   * Método para abertura do PopOver
   *
   * @param {object} event
   */
  const openPopOver = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   * Método para fechar o PopOver
   */
  const handleClosePopOver = () => {
    setAnchorEl(null);
  };

  return (
    <Wrap avoidMobileBehavior={avoidMobileBehavior}>
      <div className="field" onClick={openPopOver}>
        <span className={`${type === 'radio' && value ? 'filled' : ''}`}>
          {(type === 'radio' &&
            value !== null &&
            data.length > 0 &&
            data.find((v) => v.value.toString() === value.toString()) !== undefined &&
            data.find((v) => v.value.toString() === value.toString()).label) ||
            placeholder ||
            'Selecione'}
        </span>
        <Icon i="map-chevrondown" />
      </div>
      <Popper
        style={{ zIndex: '2000' }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        role={undefined}
        transition
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <ClickAwayListener onClickAway={handleClosePopOver}>
              <StyledPaper
                style={{
                  width: anchorEl && anchorEl.offsetWidth,
                }}
              >
                {data &&
                  data.length > 0 &&
                  data.map((v, i) => {
                    return (
                      v.value && (
                        <ItemList
                          label={v.label}
                          type={type}
                          key={i}
                          name={name}
                          index={i}
                          value={v.value.toString()}
                          onChange={handleChange}
                          checked={
                            type === 'radio'
                              ? value !== null &&
                                v.value.toString() === value.toString()
                              : value.includes(v.value.toString())
                          }
                        />
                      )
                    );
                  })}
              </StyledPaper>
            </ClickAwayListener>
          </Grow>
        )}
      </Popper>
    </Wrap>
  );
};

MultiSelect.properties = {
  ignore: true,
};

export default MultiSelect;
